export default function () {
    return {
        token: null,
        userId: null,
        name: '',
        email: '',
    }
}